<div class="flex flex-col gap-1">
    <div class="flex flex-row gap-4 items-center p-2 bg-slate-100 rounded-sm shadow-sm">
        <div>
            {{ paymentMethod.creditCard!.brand | uppercase }} ending in <span class="font-mono">{{ paymentMethod.creditCard!.lastFourDigits }}</span>
        </div>
        <div>
            Expires: {{ paymentMethod.creditCard!.expirationMonth | number:'2.0' }} / {{ paymentMethod.creditCard!.expirationYear }}
        </div>
        <div class="flex flex-row grow justify-end">
            <button (click)="onDeleteClicked()">
                @if (!isDeleting) {
                    <svg-icon [svgIcon]="deleteIcon" [small]="true" class="fill-none stroke-slate-600 hover:stroke-slate-900"></svg-icon>
                } @else {
                    <busy-spin [small]="true"></busy-spin>
                }
            </button>
        </div>
    </div>
    @if (deletionError) {
        <div class="border border-red-600 text-red-600 rounded p-1 text-xs sm:text-sm">
            Something went wrong deleting this payment method! If this issue persists, <a class="text-red-500 hover:text-red-400" href="/about#contact">please contact us.</a>
        </div>
    }
</div>
